import { UserRoles, UserValues } from 'types/user';

export const getPermissionsByRole = (role: UserRoles[] | null) => {
  if (!role?.length)
    return [
      {
        action: ['read', 'update'],
        subject: 'guest',
      },
    ];

  switch (role[0].name) {
    case UserValues.ADMIN:
      return [
        {
          action: ['read', 'update', 'create', 'delete'],
          subject: 'admin',
        },
      ];
    case UserValues.MODERATOR:
      return [
        {
          action: ['read', 'update', 'create', 'delete'],
          subject: 'moderator',
        },
      ];
    case UserValues.SUPPORT:
      return [
        {
          action: ['read', 'create'],
          subject: 'support',
        },
      ];
    default:
      return [
        {
          action: ['read', 'update'],
          subject: 'guest',
        },
      ];
  }
};
